<template>
    <div class="card mb-3" style="min-height: 60vh;">
      <div class="card-body">
        <div>
  
          <h3>POS Database Recovery</h3>
  
          <a-spin :spinning="loading">
            <div class="col-md-12" style="padding: 30px; height: 64vh;">
  
              <a-steps class="steps-navigator" :current="currentTab" @change="onChangeTab">
                <a-step title="Step 1" description="Select Account, Site and Terminal to Create Recovery Tables" :disabled='currentTab == maxTab' />
                <a-step title="Step 2" description="Download Recovery Tables" :disabled='currentTab == maxTab' />
              </a-steps>
  
              <div class="col-md-12" v-if="currentTab == 0">
                <div class="col-md-12">
                  <base-input label="Account Selection:">
                    <a-select showSearch
                              style="width: 100%"
                              placeholder=""
                              optionFilterProp="children"
                              v-model="selectedAccount">
                      <a-select-option v-for="(account, index) in accounts"
                                        :key="index"
                                        :value="account.id">
                        {{account.account_name}}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
  
                <div class="col-md-12">
                  <base-input label="Site:">
                    <a-select showSearch
                              style="width: 100%"
                              placeholder=""
                              optionFilterProp="children"
                              v-model="selectedSite">
                      <a-select-option v-for="(site, index) in sites"
                                        :key="index"
                                        :value="site.id">
                        {{site.name}}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
  
                <br/>
  
                <div class="col-md-12">
                  <base-input label="Terminal:">
                    <a-select showSearch
                              style="width: 100%"
                              placeholder=""
                              optionFilterProp="children"
                              v-model="selectedTerminal">
                      <a-select-option v-for="(terminal, index) in terminals"
                                        :key="index"
                                        :value="terminal.id">
                        {{terminal.name}}
                      </a-select-option>
                    </a-select>
                  </base-input>
                </div>
  
              </div>
  
              <div class="col-md-12" v-if="currentTab == 1">
               
                <a-list bordered :dataSource="csvList">
                <a-list-item slot="renderItem" slot-scope="item">
                    <!-- <a :href="item">
                        <a-button type="primary" icon="download" size="medium">
                            Download {{ item.split('/')[7] }}
                        </a-button>
                    </a> -->
                    <a-button type="primary" icon="download" size="medium"
                    @click="downloadRecoveryFile(item)">
                    Download {{ item.split('/')[7] }}
                    </a-button>
                </a-list-item>
                <div slot="header">Click to download.</div>
                </a-list>

              </div>
            </div>
          </a-spin>
  
          <div class="col-md-12" style="position: absolute; bottom: 0px; width: 98%; background-color: #f2f2f2 ; padding: 10px;">
            <div class="steps-action float-right">
                <a-button
                  v-if="currentTab > 0 && currentTab == maxTab"
                  @click="prevStep()"
                  :disabled='loading'>
                  Back
                </a-button>
  
                <a-button
                  v-if="currentTab < maxTab && currentTab != 1"
                  type="primary"
                  @click="proceed()"
                  style="margin-left: 8px"
                  :disabled='loading'>
                  Generate Recovery Tables
                </a-button>
            </div>
          </div>
  
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import HTTPRequest from '../../controllers/httpRequest.js';
  import secureStorage from '../../controllers/secureStorage.js';
  import axios from "axios";
  
  const defaultData = {
    loading: false,
    currentTab: 0,
    accounts: [],
    sites: [],
    terminals: [],
    selectedAccount: null,
    selectedSite: null,
    selectedTerminal: null,
    selectedInfo: {},
    requestData: {},
    password: '',
    resetOutput: {},
    csvList: []
  }
  
  export default{
    data() {
      return {
        maxTab: 1,
        ...defaultData
      }
    },
    computed: {
      ...mapState(['endPoint'])
    },
    watch: {
      selectedAccount: function() {
        if (!this.selectedAccount) { return; }
  
        this.selectedSite = null;
        this.populateSites();
      },
      selectedSite: function() {
        this.terminals = [];
        this.selectedTerminal = null;
  
        if (this.selectedSite) {
          this.populateTerminals();
        }
      }
    },
    mounted: async function() {
      await this.populateAccounts();
    },
    methods: {
      onChangeTab(current) {
        const hasErrors = this.isNotValid();
        if (hasErrors) { return; }
  
        this.currentTab = current;
      },
  
      prevStep() {
        this.currentTab--;
      },

      async downloadRecoveryFile(params){
        const _this = this;
        const config = {
          method: 'GET',
          url: params,
          headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
          responseType: 'blob'
        };
        await axios(config)
        .then(function (response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', params.split('/')[7]+'.zip');
          document.body.appendChild(link);
          link.click();
        })
        .catch(function (error) {
          _this.renderMsg('error', 'Error', "Something Went Wrong on Downloading Recovery Tables.")
        });
        this.loading = false;
      },
  
      nextStep() {
        //Arvin
        const hasErrors = this.isNotValid();
        if (hasErrors) { return; }
  
        if (this.currentTab + 1 == 1) { this.setSelectedInfo(); }
  
        this.currentTab++;
      },
  
      async resetAll() {
        Object.assign(this, { ...defaultData });
        await this.populateAccounts();
      },
  
      renderMsg(type, msg, desc) {
        this.$notification[type]({ message: msg, description: desc, });
      },
  
      async populateAccounts() {
        // Get all Valid and Active accounts
        this.loading = true;
        let accounts = await HTTPRequest.getRequest(`${this.endPoint}accounts/get_valid_accounts`, null, null)
        accounts = accounts.sort((a, b) => {
          const textA = a.account_name.toUpperCase();
          const textB = b.account_name.toUpperCase();
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        this.accounts = accounts || [];
        this.loading = false;
      },
  
      async populateSites() {
        if (!this.selectedAccount) { return; }
        this.loading = true;
        const sites = await HTTPRequest.getRequest(`${this.endPoint}sites/get_sites_with_terminal?account_id=${this.selectedAccount}`, null, null)
        this.sites = sites || [];
        this.loading = false;
      },
  
      async populateTerminals() {
        this.loading = true;
        const terminals = await HTTPRequest.getRequest(`${this.endPoint}terminals?account_id=${this.selectedAccount}&site_id=${this.selectedSite}`, null, null)
        this.terminals = (terminals || {}).data || [];
        this.loading = false;
      },
  
      setSelectedInfo() {
        const selectedAccount = this.accounts.filter(account => account.id == this.selectedAccount)[0];
        const selectedSite = this.sites.filter(site => site.id == this.selectedSite)[0];
        const selectedTerminal = this.terminals.filter(terminal => terminal.id == this.selectedTerminal)[0];
  
        this.selectedInfo = {
          accountName: selectedAccount.account_name,
          siteName: selectedSite.name,
          terminal: selectedTerminal.name
        }
      },
  
      getRequestData() {
        this.requestData.account_id = this.selectedAccount;
        this.requestData.site_id = this.selectedSite;
        this.requestData.terminal_id = this.selectedTerminal;

        // Getting account name
        const selectedAccount = this.accounts.filter(account => account.id == this.selectedAccount)[0];
        // this.requestData.account_name = selectedAccount.account_name;
  
        // Getting site code
        const selectedSite = this.sites.filter(site => site.id == this.selectedSite)[0];
        // this.requestData.site_code = selectedSite.code;
  
        // Getting selected Terminal data
        const selectedTerminal = this.terminals.filter(terminal => terminal.id == this.selectedTerminal)[0];
        // this.requestData.terminal_code = selectedTerminal.code;
      },
  
      isNotValid: function() {
        let withError = false;
        if (!this.selectedAccount) {
          this.renderMsg('error', 'Error', 'Please Select an Account');
          withError = true;
        } else if (!this.selectedSite) {
          this.renderMsg('error', 'Error', 'Please Select a Site');
          withError = true;
        } else if (!this.selectedTerminal) {
          this.renderMsg('error', 'Error', 'Please Select a Terminal');
          withError = true;
        }
  
        return withError;
      },
  
      createLogs: async function (outputData) {
        const endPoint = `${this.endPoint}admin/create_admin_logs?feature=pos_database_recovery`;
        let data = { logs: { ...this.requestData, ...outputData } }
        HTTPRequest.postRequest(endPoint, null, data);
      },
  
      proceed: async function() {
        if (this.isNotValid()) { return }
        this.loading = true;
        this.getRequestData();
        const _this = this;
        const config = {
          method: 'POST',
          url: `${this.endPoint}accounts/generate_pos_recovery`,
          headers: {'Authorization': 'Bearer ' + secureStorage.getItem("accessToken"), 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
          data: this.requestData
        };
        await axios(config)
        .then(function (response) {
          if (response.data['error']) {
            _this.renderMsg('error', 'Creating Recovery Tables Failed', response.data['error']);
          } else {
            _this.currentTab++;
            _this.renderMsg('success', 'Success Creating Recovery Tables', 'Creating Recovery Tables is successful.');
            _this.createLogs(response.data);
            _this.csvList = response.data['data']
          }
        })
        .catch(function (error) {
          _this.renderMsg('error', 'Error', "Something Went Wrong on Creating Recovery Tables.")
        });
        this.loading = false;
      }
    }
  }
  </script>
  
  <style scoped>
  .steps-navigator {
    margin-bottom: 20px;
  }
  
  p.header {
    font-size: 14px;
  }
  
  .selectedInfo-cont {
    display: inline-block;
    margin-left: 10px;
  }
  
  .selectedInfo-cont div {
    margin-bottom: 10px;
  }
  </style>
  